<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section">

    <form [formGroup]="annotatedMapEditForm">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="map-widget-name">
      </mat-form-field>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.title' | translate}}</mat-label>
              <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="map-widget-title">
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'pass.subtitle' | translate}}</mat-label>
              <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="map-widget-subtitle">
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row">
        <div class="pe-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field  appearance="outline" class="w-100">
              <mat-label>{{'pass.layout' | translate}} </mat-label>
              <mat-select formControlName="layout" class="input-group">
                <mat-option value="singleMap">{{'pass.map.single' | translate}}</mat-option>
                <mat-option value="horizontal">{{'pass.map.horizontal' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="ps-2 flex-grow-1">
          <div class="input-group">
            <mat-form-field  appearance="outline" class="w-100">
              <mat-label>{{'pass.style' | translate}}</mat-label>
              <mat-select formControlName="style" class="input-group">
                <mat-option value="satellite">{{'pass.map.satellite' | translate}}</mat-option>
                <mat-option value="streets">{{'pass.map.streets' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <label class="m-2">{{'pass.map.ANNOTATIONS' | translate}}</label>
      <mat-tab-group class="mb-4">
        <mat-tab label="{{'pass.widgets.map' | translate}}">

          <div id="map-edit-dialog-{{annotatedMapEditData.id}}" class="map"></div><hr>

        </mat-tab>
        <mat-tab label="{{'pass.list' | translate}}" style="max-height: 200px;">

          <div class="d-flex justify-content-start my-3">
            <button mat-button class="secondary-gray-button me-2" (click)="addAnnotationDialog()" [disabled]="translationMode">
              <mat-icon>add_circle</mat-icon> {{'pass.map.add_annotation' | translate}}
            </button>
            <button mat-button class="secondary-gray-button" (click)="addDynamicAnnotation()" [disabled]="translationMode">
              <mat-icon>add_location_alt</mat-icon> {{'pass.map.add_dynamic_annotation' | translate}}
            </button>
          </div>

          <div cdkDropList (cdkDropListDropped)="drop($event)">
            @for (a of allAnnotationsMap; track a; let i = $index) {
              <div class="p-2 border-bottom" style="overflow: hidden; background-color: white;" (click)="openAnnotationDialog(a, i);" id="annotation-list-item" cdkDrag>
                <div class="d-flex align-items-center">
                  @if (!a.dynamic) {
                    <div style="width: 10%;">
                      @if ((a.type && a.type=='point') || !a.type) {
                        <div matListItemIcon style="position: relative; width: 70%;">
                          <img src="./../../../assets/img/narravero-pin.svg" alt="pi-logo" width="45" height="45">
                          <span class="image-title-text"> {{a.badge ? a.badge : (i+1)}}</span>
                        </div>
                      }
                      <!-- <mat-icon matListItemIcon *ngIf="!a.type">place</mat-icon> -->
                      <!-- <mat-icon matListItemIcon *ngIf="a.type && a.type=='point'"> place</mat-icon> -->
                      @if (a.type && a.type=='line') {
                        <mat-icon matListItemIcon>timeline</mat-icon>
                      }
                      @if (a.type && a.type=='polygon') {
                        <mat-icon matListItemIcon>photo_size_select_small</mat-icon>
                      }
                    </div>
                  }
                  @if (a.dynamic) {
                    <div style="width: 10%;">
                      <div matListItemIcon style="position: relative; width: 70%;">
                        <img src="./../../../assets/img/narravero-pin.svg" alt="pi-logo" width="45" height="45">
                        <span class="image-title-text"> {{a?.properties?.badge ? a.properties.badge : (i+1)}}</span>
                      </div>
                      <!-- <mat-icon matListItemIcon >pin_drop</mat-icon> -->
                    </div>
                  }
                  <div class="d-flex flex-row justify-content-between mb-1 mt-1 align-items-center" style="width: 90%; cursor:pointer;">
                    @if (!a.dynamic) {
                      <div>
                        @if (a.name) {
                          <div matListItemTitle>{{a.name}}</div>
                        }
                        @if (a.title) {
                          <div matListItemTitle>{{a.title}}</div>
                        }
                        @if (!a.name && !a.title) {
                          <div matListItemTitle>{{'pass.map.annotation' | translate}} {{i+1}}</div>
                        }
                        @if (a.subtitle) {
                          <div matListItemLine>{{a.subtitle}}</div>
                        }
                        @if (a.lat || a.lng) {
                          <div matListItemLine>{{a.lat}} , {{a.lng}}</div>
                        }
                        @if (a.coordinate && !a.lat) {
                          <div matListItemLine>{{a.coordinate[0]}} , {{a.coordinate[1]}}</div>
                        }
                      </div>
                    }
                    @if (a.dynamic) {
                      <div>
                        @if (a.properties) {
                          <div>
                            @if (a.properties.name) {
                              <div matListItemTitle>{{a.properties.name}}</div>
                            }
                            @if (a.properties.title) {
                              <div matListItemTitle>{{a.properties.title}}</div>
                            }
                            @if (!a.properties.name && !a.properties.title) {
                              <div matListItemTitle>{{'pass.map.annotation_dynamic' | translate}} {{i+1}}</div>
                            }
                            @if (a.properties.subtitle) {
                              <div matListItemLine>{{a.properties.subtitle}}</div>
                            }
                            @if (a.properties.lat || a.properties.lng) {
                              <div matListItemLine>{{a.properties.lat}} , {{a.properties.lng}}</div>
                            }
                            @if (a.properties.coordinate && !a.properties.lat) {
                              <div matListItemLine>{{a.properties.coordinate[0]}} , {{a.properties.coordinate[1]}}</div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <button mat-icon-button class="delete-button" (click)="deleteAnnotation(i);" [disabled]="translationMode">
                      <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

        </mat-tab>
      </mat-tab-group>

      <div [app-widget-styling] = "{'form': annotatedMapEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>

    </form>

  </section>
  <div  [app-widget-edit-filters] = "{'form':annotatedMapEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
</div>